/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSummaryQueryVariables = {
    orgRelayId: string;
    calendarIds: Array<string | null>;
};
export type EventSummaryQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"EventSummary_org">;
    } | null;
};
export type EventSummaryQuery = {
    readonly response: EventSummaryQueryResponse;
    readonly variables: EventSummaryQueryVariables;
};



/*
query EventSummaryQuery(
  $orgRelayId: ID!
  $calendarIds: [String]!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...EventSummary_org_3nh1j1
    }
    id
  }
}

fragment AutopilotFlexibility_org on Org {
  userWorkingHours(resolveOverrides: false) {
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
    id
  }
}

fragment AutopilotFormSaveOnEdit_org_3nh1j1 on Org {
  ...AutopilotForm_org
  id
  experiments
  personsByUserIdsErrorable(userIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotForm_org on Org {
  ...AutopilotFlexibility_org
  ...OrganizerAutopilotPausedFreemiumCallout_org
  id
  experiments
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  pendingInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment EventSummaryAutopilot_org on Org {
  id
  experiments
}

fragment EventSummaryColorCategory_org on Org {
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      shadowCalendarId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  id
  experiments
  eventColoringSettingsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on EventColoringSettings {
      eventCategoryColorings {
        googleColorKey
        eventCategory
        active
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventSummaryRecurrence_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummaryTime_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummary_org_3nh1j1 on Org {
  ...EventSummaryAutopilot_org
  ...EventSummaryColorCategory_org
  ...EventSummaryRecurrence_org
  ...EventSummaryTime_org
  ...EventTimeAndRecurrence_org
  ...AutopilotFormSaveOnEdit_org_3nh1j1
  id
  experiments
  primaryOrgCalendar
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      focusTimeSyncAll
      focusTimeIdealMinutesPerWeek
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamCalendarId
        teamName
        createdBy {
          value
          id
        }
        teamMembers {
          person {
            __typename
            id
            personId
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        invitedMembers {
          person {
            __typename
            id
            personId
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  }
  userGoals(first: 1000000) {
    edges {
      node {
        id
        name
        options {
          specificOptions {
            __typename
            ... on GoalWithinWeekOptions {
              maxMinutesPerBlock
            }
            ... on GoalWithinDayOptions {
              minimumDuration
              idealDuration
              minTimeSlot
              maxTimeSlot
            }
          }
        }
      }
    }
  }
}

fragment EventTimeAndRecurrence_org on Org {
  id
  primaryOrgCalendar
}

fragment OrganizerAutopilotPausedFreemiumCallout_org on Org {
  id
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v3 = [
        {
            "kind": "Variable",
            "name": "calendarIds",
            "variableName": "calendarIds"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v6 = [
        (v5 /*: any*/)
    ], v7 = {
        "kind": "InlineFragment",
        "selections": (v6 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v10 = {
        "kind": "InlineFragment",
        "selections": [
            (v8 /*: any*/),
            (v9 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v12 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v13 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetCalendarId",
            "storageKey": null
        } as any,
        (v5 /*: any*/)
    ], v14 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v16 = [
        (v4 /*: any*/),
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "list",
                    "plural": true,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emails",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "primaryEmail",
                            "storageKey": null
                        },
                        (v14 /*: any*/),
                        (v15 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "PersonList",
            "abstractKey": null
        } as any,
        {
            "kind": "InlineFragment",
            "selections": [
                (v9 /*: any*/)
            ],
            "type": "GraphEntityError",
            "abstractKey": null
        } as any
    ], v17 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v4 /*: any*/),
                (v5 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "personId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                (v15 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                },
                (v14 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "EventSummaryQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": (v3 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "EventSummary_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "EventSummaryQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "shadowCalendarSettingsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "shadowCalendarId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "focusTimeSyncAll",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "focusTimeIdealMinutesPerWeek",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ShadowCalendarSettings",
                                            "abstractKey": null
                                        },
                                        (v7 /*: any*/),
                                        (v10 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "eventColoringSettingsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "EventCategoryColoring",
                                                    "kind": "LinkedField",
                                                    "name": "eventCategoryColorings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "googleColorKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "eventCategory",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "active",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isUserSet",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "EventColoringSettings",
                                            "abstractKey": null
                                        },
                                        (v7 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "resolveOverrides",
                                            "value": false
                                        }
                                    ],
                                    "concreteType": "UserWorkingHours",
                                    "kind": "LinkedField",
                                    "name": "userWorkingHours",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingHours",
                                            "kind": "LinkedField",
                                            "name": "workingHours",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "type",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "timeZone",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DaySetting",
                                                    "kind": "LinkedField",
                                                    "name": "daySettings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "day",
                                                            "storageKey": null
                                                        },
                                                        (v11 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DayOverride",
                                                    "kind": "LinkedField",
                                                    "name": "dayOverrides",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "date",
                                                            "storageKey": null
                                                        },
                                                        (v11 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v5 /*: any*/)
                                    ],
                                    "storageKey": "userWorkingHours(resolveOverrides:false)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgAccountingPeriod",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DateRange",
                                                    "kind": "LinkedField",
                                                    "name": "periodRange",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "minDate",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "maxDate",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaMax",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaUsed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "enforcementState",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgAccountingPeriod",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v8 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "featureGrid",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PaymentStateMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "stateMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PrimaryBillingGroupMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "primaryBillingGroupMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PaymentSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": (v6 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "FeatureGrid",
                                            "abstractKey": null
                                        },
                                        (v10 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "nextDefragTime",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "millis",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "DefragTime",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v12 /*: any*/),
                                    "concreteType": "SuggestedOrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SuggestedOrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedOrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v13 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "suggestedInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v12 /*: any*/),
                                    "concreteType": "OrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "pendingInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v13 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "pendingInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "userIds",
                                            "value": []
                                        }
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByUserIdsErrorable",
                                    "plural": false,
                                    "selections": (v16 /*: any*/),
                                    "storageKey": "personsByUserIdsErrorable(userIds:[])"
                                },
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByCalendarIdsErrorable",
                                    "plural": false,
                                    "selections": (v16 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "userTeams",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamCalendarId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "value",
                                                                    "storageKey": null
                                                                },
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "teamMembers",
                                                            "plural": true,
                                                            "selections": (v17 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "invitedMembers",
                                                            "plural": true,
                                                            "selections": (v17 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v12 /*: any*/),
                                    "concreteType": "GoalConnection",
                                    "kind": "LinkedField",
                                    "name": "userGoals",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Goal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "GoalOptions",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "specificOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v4 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "maxMinutesPerBlock",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "GoalWithinWeekOptions",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "minimumDuration",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "idealDuration",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "minTimeSlot",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "maxTimeSlot",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "GoalWithinDayOptions",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "userGoals(first:1000000)"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "93e690b3a39af26f64530d8012548372",
            "id": null,
            "metadata": {},
            "name": "EventSummaryQuery",
            "operationKind": "query",
            "text": "query EventSummaryQuery(\n  $orgRelayId: ID!\n  $calendarIds: [String]!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...EventSummary_org_3nh1j1\n    }\n    id\n  }\n}\n\nfragment AutopilotFlexibility_org on Org {\n  userWorkingHours(resolveOverrides: false) {\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AutopilotFormSaveOnEdit_org_3nh1j1 on Org {\n  ...AutopilotForm_org\n  id\n  experiments\n  personsByUserIdsErrorable(userIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotForm_org on Org {\n  ...AutopilotFlexibility_org\n  ...OrganizerAutopilotPausedFreemiumCallout_org\n  id\n  experiments\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment EventSummaryAutopilot_org on Org {\n  id\n  experiments\n}\n\nfragment EventSummaryColorCategory_org on Org {\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      shadowCalendarId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  id\n  experiments\n  eventColoringSettingsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        googleColorKey\n        eventCategory\n        active\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment EventSummaryRecurrence_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummaryTime_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummary_org_3nh1j1 on Org {\n  ...EventSummaryAutopilot_org\n  ...EventSummaryColorCategory_org\n  ...EventSummaryRecurrence_org\n  ...EventSummaryTime_org\n  ...EventTimeAndRecurrence_org\n  ...AutopilotFormSaveOnEdit_org_3nh1j1\n  id\n  experiments\n  primaryOrgCalendar\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      focusTimeSyncAll\n      focusTimeIdealMinutesPerWeek\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamCalendarId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamMembers {\n          person {\n            __typename\n            id\n            personId\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        invitedMembers {\n          person {\n            __typename\n            id\n            personId\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n      }\n    }\n  }\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        name\n        options {\n          specificOptions {\n            __typename\n            ... on GoalWithinWeekOptions {\n              maxMinutesPerBlock\n            }\n            ... on GoalWithinDayOptions {\n              minimumDuration\n              idealDuration\n              minTimeSlot\n              maxTimeSlot\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventTimeAndRecurrence_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment OrganizerAutopilotPausedFreemiumCallout_org on Org {\n  id\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f5e41353dac8d029993b44247d43e528';
export default node;
